import * as yup from "yup";

export const RenameCategorySchema = yup.object().shape({
  newName: yup.string().required(),
});
